module.exports = __webpack_public_path__ + "static/media/logo-berkley-white.fb4f021a.svg";